/**
 * The page language the sitewide chrome renders in.
 *
 * Kept apart from `site-chrome.ts` (which reads the page registry) so the
 * client-side chrome picker can import it without shipping the registry.
 */
export type ChromeLocale = "en" | "hi";

/** `/hi` and everything under `/hi/` is Hindi; every other path is English. */
export function chromeLocaleForPath(pathname: string | null | undefined): ChromeLocale {
  return pathname === "/hi" || pathname?.startsWith("/hi/") ? "hi" : "en";
}

/**
 * The language a chrome LABEL is written in (Devanagari → Hindi). A link's
 * `hreflang` names its destination's language; its `lang` must name the
 * label's, so a Hindi label on an English page (or an English label on a
 * Hindi page) is announced in the right voice, and a Hindi label that leads
 * to an English policy page is not.
 */
export function chromeLabelLocale(label: string): ChromeLocale {
  return /[\u0900-\u097F]/.test(label) ? "hi" : "en";
}
